import React, {useEffect} from "react";
import api from "../../utils/api";
import {Text, Link} from "react-aria-components";
import {Navigate} from "react-router-dom";
import {LuTrash2, LuPencil} from "react-icons/lu";
import "./UserList.css"
import DefaultButton, {WarningButton} from "../../components/Buttons/DefaultButton/DefaultButton";
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";
import PricingPlans from "../../components/PricingPlans/PricingPlans.js";

function UserList() {
    const [users, setUsers] = React.useState([])
    const [redirect, setRedirect] = React.useState(null)
    const [user, setUser] = React.useState("")
    const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false)
    const [showOrgDeleteConfirmation, setShowOrgDeleteConfirmation] = React.useState(false)
    const [userToDelete, setUserToDelete] = React.useState(null)

    let isAdmin = false
    if (user) {
        if (user.email === "john@veilstream.com") {
            isAdmin = true
        }
        if (user.email === "steve@veilstream.com") {
            isAdmin = true
        }
    }

    function deleteUser() {
        api.deleteUser(userToDelete.id).then(() => {
            api.listUsers().then(data => {
                setUsers(data)
            })
        })
        setShowDeleteConfirmation(false)
        setUserToDelete(null)
    }

    function deleteOrganization() {
        api.deleteOrganization().then(() => {
            setRedirect("/logout")
        })
        setShowOrgDeleteConfirmation(false)
    }

    function onCancelDelete() {
        setShowDeleteConfirmation(false)
        setShowOrgDeleteConfirmation(false)
        setUserToDelete(null)
    }

    useEffect(() => {
        api.listUsers().then(data => {
            setUsers(data)
            api.getCurrentUser().then(result => {
                setUser(result)
            })
        })
    }, []);

    if (users === null || users === undefined) {
        return <LoadingLayout />
    }

    if (redirect) {
        return <Navigate to={redirect} />
    }

    const rows = users.map((member) => {
        return <div key={member.id} className="member-row" data-name={member.email}>
            <div className="member-row-section permission">
                {(member.email === user["email"]) ?
                    <div>{member.permissionLevel} (Me)</div> :
                    <div>{member.permissionLevel}</div>}
            </div>
            <div className="member-row-section email">{member.email}</div>
            <div className="member-row-section actions">
                <div className="action-edit">
                    <Link href={`/organization_user/${member.id}`}>
                        <LuPencil/>
                    </Link>
                </div>
                {(member.permissionLevel !== "owner" && member.id !== user["id"]) ?
                    <div className="action-delete">
                        <LuTrash2
                        onClick={() => {
                            setUserToDelete(member)
                            setShowDeleteConfirmation(true)
                        }}/>
                    </div> : <div className="action-no-delete"></div>}
            </div>
        </div>
    })

    let userDeletionModal = null
    if (showDeleteConfirmation) {
        userDeletionModal = <ConfirmationModal
            title="Delete User"
            message="Are you sure you want to delete this User?"
            onConfirm={deleteUser}
            onCancel={onCancelDelete}
        />
    }

    let orgDeletionModal = null
    if (showOrgDeleteConfirmation) {
        orgDeletionModal = <ConfirmationModal
            title="Delete Organization"
            message="Are you sure you want to delete this organization?"
            onConfirm={deleteOrganization}
            onCancel={onCancelDelete}
        />
    }
    const content = <>
        {userDeletionModal}
        {orgDeletionModal}
        <div className="members-list">{rows}</div>
        {isAdmin ? <PricingPlans /> : null}
        <div className="bottom-actions">
            <WarningButton
                text="Delete Organization"
                className="delete-organization"
                onPress={() => {
                    setShowOrgDeleteConfirmation(true)
                }}
            />
        </div>
    </>

    const actionButton = <div className="action-buttons">
        <DefaultButton text="Add Admin User" onPress={() => {
            setRedirect(`/organization_user/create`)
        }} />
    </div>

    return <FullWidthLayout
        title="My Organization"
        mainContent={content}
        actionButton={actionButton}
    />
}

export default UserList;
